import React from 'react';

const Loadable = React.lazy(() => import('../../pages/StatsFeature/index'));

export default Loadable;
